import ContractsPanel from 'src/components/ConnectedVehicle/Contracts/ContractsPanel/ContractsPanel';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(ContractsPanel);